// extracted by mini-css-extract-plugin
export default {"richText":"job-listing-module__richText___pWUmI"};